module.exports = __webpack_public_path__ + "img/skier-type-1.d0a1b233.png";